<div class="form-check form-switch" (click)="stopPropagation($event)" (keypress)="stopPropagation($event)" tabindex="0">
  <input
    [id]="id"
    class="form-check-input"
    type="checkbox"
    [(ngModel)]="checked"
    (ngModelChange)="onCheckedChanged($event)"
  />
  <label class="form-check-label" [for]="id"><ng-content></ng-content></label>
</div>
